<div class="p-inputgroup board-search">
    <form action="" (ngSubmit)="onSearch(search)" (keydown.enter)="onSearch(search)">
        <button type="submit" pButton pRipple icon="pi pi-search" class="p-button-rounded p-button-text"></button>
        <input #search type="text" pInputText placeholder="Search board" class="p-d-none p-d-md-block" >
    </form>
</div>